import { http } from "./http";

export const propertyCensusSnapshotsApi = {
  list: (params) =>
    http.get("/property-census-snapshots", { params }).then((r) => r.data),

  getById: (id) =>
    http.get(`/property-census-snapshots/${id}`).then((r) => r.data.data),

  create: (payload) =>
    http.post("/property-census-snapshots", payload).then((r) => r.data.data),

  update: (id, payload) =>
    http
      .put(`/property-census-snapshots/${id}`, payload)
      .then((r) => r.data.data),

  upsert: (payload) =>
    http
      .post("/property-census-snapshots/upsert", payload)
      .then((r) => r.data.data),

  syncCensus: (id) =>
    http
      .post(`/property-census-snapshots/${id}/census-sync`)
      .then((r) => r.data.data),
};
